/**
 * X cards
 */

 var x_cards_init = function(instance) {

  const centeredSlides = (instance.getAttribute('data-centeredslides') === 'true');
  const spaceBetween = parseInt(instance.getAttribute('data-spacebetween'));
  const slidesPerView = 3;
  const breakpoints = {
    0: {
      slidesPerView: 1.25,
      spaceBetween: 32,
    },
    850: {
      slidesPerView: 2.25,
      spaceBetween: spaceBetween,
    },
    1440: {
      slidesPerView: 3,
      spaceBetween: spaceBetween,
    }
  };

  const maybeHideSwiperNavigation = (swiper) => {

    if (swiper.isBeginning && swiper.isEnd) {
      swiper.el.classList.add('is-without-navigation');
    } else {
      swiper.el.classList.remove('is-without-navigation');
    }
  };

  const swiper = new Swiper(instance, {
    direction: 'horizontal',
    loop: false,
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    noSwiping: false,
    observer: true,
    resizeReInit: true,
    breakpoints: breakpoints,
    centeredSlides: centeredSlides,

    // If we need pagination
    pagination: {
      el: instance.querySelector('.swiper-pagination'),
    },

    // Navigation arrows
    navigation: {
      nextEl: instance.querySelector('.swiper-button-next'),
      prevEl: instance.querySelector('.swiper-button-prev'),
    },

    // And if we need scrollbar
    scrollbar: {
      el: instance.querySelector('.swiper-scrollbar'),
    },

  });

  maybeHideSwiperNavigation(swiper);
  setTimeout(function (swiper) {
    maybeHideSwiperNavigation(swiper);
  }, 1000, swiper);

  window.addEventListener("resize", function(){
    setTimeout(function () {

      swiper.slideReset();
      swiper.update();
      swiper.detachEvents();
      swiper.attachEvents();

      maybeHideSwiperNavigation(swiper);

      // swiper.reInit();

    }, 1000);
  });

};

const x_cards = () => {
  const cards = document.querySelectorAll('.js-x-cards');

  for (let i = 0; i < cards.length; i++) {
    x_cards_init(cards[i]);
  }
};

x_cards();
